"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "buildUrl", {
  enumerable: !0,
  get: function a() {
    return _buildUrl.default;
  }
}), exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _invariant = _interopRequireDefault(require("invariant")),
    _buildUrl = _interopRequireDefault(require("./modules/buildUrl")),
    _instafeed = _interopRequireDefault(require("./modules/instafeed")),
    _default = function () {
  var a = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function a(b) {
    var c, d;
    return _regenerator.default.wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            return c = {
              accessToken: null,
              clientId: null,
              get: "user",
              limit: 60,
              locationId: null,
              resolution: "thumbnail",
              sortBy: "none",
              tagName: null,
              userId: null
            }, (0, _invariant.default)("object" === (0, _typeof2.default)(b), "You must pass an Object of options to the instafeed-lite function"), d = Object.assign(c, b), a.abrupt("return", (0, _instafeed.default)(d));

          case 4:
          case "end":
            return a.stop();
        }
      }
    }, a, this);
  }));
  return function () {
    return a.apply(this, arguments);
  };
}();

exports.default = _default;